import {
  ConfirmationApproveReactivateIcon,
  ReactivateIcon,
  SmileyFace,
} from "@/assets";
import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ToastMessage, type } from "@/lib/toastr";
import { unsuspendTeamMember } from "@/services/Settings.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import { useState } from "react";

const Reactivate = ({ name, id, handleDialogItemOpenChange }) => {
  const queryClient = useQueryClient();
  const [step, setStep] = useState(1);
  const mutation = useMutation({
    mutationFn: async (id) => await unsuspendTeamMember(id),
    mutationKey: ["suspendTeam"],
    onSuccess: (res) => {
      queryClient.clear();
      setStep(2);
      ToastMessage(type.SUCCESS, "Team member unsuspend successfully");
    },
    onError: (err) => {
      handleDialogItemOpenChange(false);
      setStep(1);
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });
  return (
    <div className="flex flex-col items-center justify-center gap-10 p-8">
      <div className="flex flex-col gap-9">
        <DialogHeader className="flex flex-col items-center text-center ">
          {step == 1 ? (
            <ReactivateIcon />
          ) : (
            <ConfirmationApproveReactivateIcon />
          )}
          <div className="flex flex-col gap-2">
            <DialogTitle className="text-center text-green-3">
              {step == 1
                ? "Reactivate This Team Member?"
                : "Team Member Reactivated Successfully!"}
            </DialogTitle>
            <DialogDescription className="text-center">
              {step == 1
                ? "Are you sure you want to reactivate this member?"
                : `${name} was successfully reactivated into  the Treasura platform`}
            </DialogDescription>
          </div>
        </DialogHeader>
        {step === 1 && (
          <div className="flex flex-col justify-around bg-off-white-1 gap-4 w-full rounded-[8px] py-5 px-4">
            <div className="flex items-center gap-1 ">
              <SmileyFace />
              <span className="text-sm text-gray">
                Reactivate this team member will cause;
              </span>
            </div>
            <ul className="gap-6 px-3 list-disc list-inside">
              <li className="text-xs text-gray-80">
                Member will now be able to log into Treasura
              </li>
              <li className="text-xs text-gray-80 ">
                Member’s role will be reinstated.
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="flex flex-col items-center w-full ">
        {step == 1 ? (
          <>
            <Button
              type="submit"
              className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] w-full"
              onClick={() => mutation.mutate(id)}
            >
              {mutation?.isPending && (
                <Loader2 className="text-white animate-spin" />
              )}
              Yes, I want to reactivate this member <ChevronRight />
            </Button>
            <DialogClose asChild onClick={() => setStep(1)}>
              <Button type="button" variant="ghost">
                No, I want to cancel
              </Button>
            </DialogClose>
          </>
        ) : (
          <DialogClose asChild>
            <ChevronLeft /> Back to dashboard
          </DialogClose>
        )}
      </div>
    </div>
  );
};

export default Reactivate;
